let intialState = {
    isFullScreen: false
}

export default function whiteboardReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case 'FULL_SCREEN_ON':
            stateCopy.isFullScreen = true;
            return stateCopy;
        case 'FULL_SCREEN_OFF':
            stateCopy.isFullScreen = false;
            return stateCopy;
        case 'GET_SUBJECT_WHITEBOARD':
            stateCopy.subjectWhiteboard = action.payload;
            return stateCopy;
        case 'UPLOAD_RECORDING_START':
            stateCopy.isUploading = true;
            return stateCopy;
        case 'UPLOAD_RECORDING_SUCCESS':
            stateCopy.isUploading = false;
            return stateCopy;
        case 'UPLOAD_RECORDING_FAIL':
            stateCopy.isUploading = false;
            return stateCopy;
        case 'GET_WHITEBOARD_LIST':
            stateCopy.isWhiteboardLoading = false;
            stateCopy.whiteboardList = action.payload;
            return stateCopy;
        case 'GET_WHITEBOARD_DETAILS':
            stateCopy.whiteboardDetails = action.payload;
            return stateCopy;
        case 'UPDATE_WHITEBOARD_STATUS':
            stateCopy.whiteboardList = stateCopy.whiteboardList.map(item => {
                if (item._id === action.payload.whiteboard_id) {
                    return { ...item, active: action.payload.active };
                }
                return item;
            });
            return stateCopy;
        case 'ENABLE_WHITEBOARD_STATUS':
            stateCopy.whiteboardList = stateCopy.whiteboardList.map(item => {
                if (item._id === action.payload.whiteboard_id) {
                    return { ...item, enable: action.payload.enable };
                }
                return item;
            });
            return stateCopy;
        case 'GET_STUDENT_WHITEBOARD_LIST':
            stateCopy.studentWhiteboardList = action.payload;
            stateCopy.isStudentWhiteboardLoading = false;
            return stateCopy;
        case 'GET_STUDENT_WHITEBOARD_DETAILS':
            stateCopy.studentWhiteboardDetails = action.payload;
            return stateCopy;
        case 'GET_STUDENT_FACULTIES':
            stateCopy.studentFaculties = action.payload;
            return stateCopy;
        default:
            return stateCopy;
    }
}
